export const namespace =
  'canalplus.block.oneshop.unauthenticated_renewal_summary';
export { default as Component } from './components/Summary';
export { default as propsFormatter } from './propsFormatter';
